var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandardLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30.5,
    fill: "#E2EFFF",
    stroke: "#0061AF",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.142 20.538V23.45H42.608V20.538H31.142ZM29.946 26.752V29.664H44.038V26.752H29.946ZM35.042 28.182V39.622C35.042 39.934 34.938 40.012 34.6 40.038C34.262 40.038 33.144 40.038 32.13 39.986C32.52 40.922 32.91 42.274 33.014 43.21C34.782 43.21 36.056 43.132 37.018 42.612C37.98 42.092 38.214 41.208 38.214 39.674V28.182H35.042ZM39.072 32.81C40.19 35.514 41.23 38.972 41.516 41.13L44.324 40.09C43.986 37.932 42.842 34.578 41.646 31.952L39.072 32.81ZM31.064 32.056C30.466 34.734 29.374 37.568 28.048 39.388C28.698 39.726 29.92 40.532 30.492 40.974C31.818 38.946 33.118 35.748 33.872 32.706L31.064 32.056ZM19.858 24.048V26.934H29.634V24.048H19.858ZM23.498 18.926V43.34H26.592V18.926H23.498ZM23.082 26.024C22.51 29.092 21.054 33.044 19.416 35.124C19.962 35.956 20.716 37.334 20.976 38.166C22.796 35.592 24.278 30.652 24.98 26.648L23.082 26.024ZM26.462 27.35L25.084 28.728C25.89 29.846 27.658 32.654 28.36 34.084L30.024 31.64C29.504 30.964 27.086 28 26.462 27.35Z",
    fill: "#0061AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardLevel);
export default __webpack_public_path__ + "static/media/standard_level.a301edd6af99ba6d2b8015bdb4121b2a.svg";
export { ForwardRef as ReactComponent };